module.exports = __webpack_public_path__ + "1445918d7d027be312362ca518b04ca4.png";